import PageWithNavbar from "@/components/PageWithNavbar";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

const SupportPage = () => {
  return (
    <PageWithNavbar>
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-8">
            <div className="mx-auto text-left mb-8">
                <h1 className="text-3xl md:text-4xl font-bold mx-auto text-left">
                    Doyen <span className="bg-gradient-to-b from-primary/60 to-primary text-transparent bg-clip-text">Support</span>
                </h1>
                <p className="text-xl text-muted-foreground mt-2" >
                    Contact us any time for assistance or with inquiries regarding our platform.
                </p>
            </div>
            <Card className="mb-4">
                  <CardHeader>
                    <CardTitle>Application Support</CardTitle>
                    <CardDescription>Find support information on the Landing Page.</CardDescription>
                  </CardHeader>
                  <CardContent>
                    <p>For Premium users this is where you will find our phone number.</p>
                    <p className="text-muted-foreground">Note: This information is automatically adjusted to your system's timezone.</p>
                    <img src="/support-example.png" alt="Support Illustration" />
                    <p className="text-muted-foreground text-sm mb-4">In this image, the phone number has been redacted.</p>
                  </CardContent>
            </Card>
            <p>General Inquiries</p>
            <p className="text-primary mb-2"><b><a href="mailto:contact@doyentrading.com">contact@doyentrading.com</a></b></p>
            <p>Technical and Account Support</p>
            <p className="text-primary mb-4"><b><a href="mailto:support@doyentrading.com">support@doyentrading.com</a></b></p>
        </div>
    </div>
    </PageWithNavbar>
  );
}

export default SupportPage;